import { VStack, Spinner, Text } from '@cad-arc';
import { SectionTitle } from '../../../../fr-event-common-components/section-title';
import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { BoloAssociationCard } from './bolo-association-card';
import { BoloAssociation } from '@mark43/cad-api';

const AssociationList = ({
    associations,
    boloId,
}: {
    associations: BoloAssociation[];
    boloId: number;
}) => {
    if (associations.length) {
        // Fragment required here due to return type.
        return (
            <>
                {associations.map((boloAssociation) => (
                    <BoloAssociationCard
                        currentBoloId={boloId}
                        key={boloAssociation.entityId}
                        boloAssociation={boloAssociation}
                    />
                ))}
            </>
        );
    }

    return (
        <Text fontSize="sm" color="tertiary">
            --
        </Text>
    );
};

export const FrBoloPanelAssociations = () => {
    const metadata = useBoloPanelMetadata();

    if (!metadata) {
        return <Spinner />;
    }

    return (
        <VStack alignItems="flex-start" w="100%" gap={2}>
            <SectionTitle title="Associated Events" />
            <AssociationList associations={metadata.associatedEvents} boloId={metadata.boloId} />
            <SectionTitle title="Associated BOLOs" />
            <AssociationList associations={metadata.associatedBolos} boloId={metadata.boloId} />
        </VStack>
    );
};
